export default __webpack_public_path__ + "static/media/logo.f20aa8ff.svg";